import React, { Component } from 'react';
import { resolvePublicAssets } from '../../../../utils';
import './style.scss';
import {
  trackProfileAvatar,
  trackProfileName,
} from '../../../../utils/generalGaEventAnalytics';
import { CUSTOMER_GENDER } from '../../../../constants/constants';

interface CustomerProfileInformationProps {
  customerName: string;
  customerIconGender: string;
}

interface CustomerProfileInformationState {}

class CustomerProfileInformation extends Component<
  CustomerProfileInformationProps,
  CustomerProfileInformationState
> {
  componentDidMount() {}

  render() {
    const { customerName, customerIconGender } = this.props;
    return (
      <div className="customer-profile-information content-align-level">
        <div
          className="customer-profile-information__img"
          onClick={() => {
            trackProfileAvatar();
          }}
        >
          {customerIconGender === CUSTOMER_GENDER.FEMALE && (
            <img
              src={resolvePublicAssets(
                `assets/images/customer-profile/female-avatar.png`,
              ).replace('.png', '@3x.png')}
              alt=""
            />
          )}
          {customerIconGender === CUSTOMER_GENDER.MALE && (
            <img
              src={resolvePublicAssets(
                `assets/images/customer-profile/male-avatar.png`,
              ).replace('.png', '@3x.png')}
              alt=""
            />
          )}
          {customerIconGender === CUSTOMER_GENDER.UNKNOWN && (
            <img
              src={resolvePublicAssets(
                `assets/images/customer-profile/unisex-avatar.png`,
              ).replace('.png', '@3x.png')}
              alt=""
            />
          )}
          {!customerIconGender && (
            <img
              src={resolvePublicAssets(
                `assets/images/customer-profile/unisex-avatar.png`,
              ).replace('.png', '@3x.png')}
              alt=""
            />
          )}
        </div>
        <div
          className="customer-profile-information__span"
          onClick={() => {
            trackProfileName();
          }}
        >
          {customerName}
        </div>
      </div>
    );
  }
}

export default CustomerProfileInformation;
